import { render, staticRenderFns } from "./NaturalSearchInput.vue?vue&type=template&id=51ccce0a&scoped=true&"
import script from "./NaturalSearchInput.vue?vue&type=script&lang=ts&"
export * from "./NaturalSearchInput.vue?vue&type=script&lang=ts&"
import style0 from "./NaturalSearchInput.vue?vue&type=style&index=0&id=51ccce0a&prod&lang=scss&scoped=true&"
import style1 from "./NaturalSearchInput.vue?vue&type=style&index=1&id=51ccce0a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ccce0a",
  null
  
)

export default component.exports